import { Share } from "@capacitor/share";

import { copyToClipboard } from "./clipboard";
import { isNativeApp } from "./native";

export type ShareOutcome = "shared" | "dismissed" | "copied" | "failed";

// Opens the system share sheet where there is one - always in the app (Android
// WebView has no navigator.share), and in touch browsers that support Web Share -
// and copies the link everywhere else. Callers pick the toast from the outcome.
export async function shareLink({ title, url }: { title: string; url: string }): Promise<ShareOutcome> {
  if (isNativeApp) {
    try {
      await Share.share({ title, url, dialogTitle: title });
      return "shared";
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      if (/cancel/i.test(message)) return "dismissed";
      // Fall through to copying the link.
    }
  } else if (typeof navigator.share === "function" && window.matchMedia?.("(pointer: coarse)").matches) {
    try {
      await navigator.share({ title, url });
      return "shared";
    } catch (error) {
      if ((error as DOMException)?.name === "AbortError") return "dismissed";
    }
  }

  const result = await copyToClipboard(url);
  return result.success ? "copied" : "failed";
}
